import { Helmet } from 'react-helmet-async';
import { Navigate, useParams } from 'react-router';

import { hasPermission } from 'src/utils/has-permissions';

import { useAuthContext } from 'src/auth/hooks';
import { AuthPermissions } from 'src/auth/permissions';

import AdvancedPaymentCreateView from 'src/sections/advanced-payments/view/advanced-payments-create-view';

export default function AdvancedPaymentCreatePage() {
  const { user: authUser } = useAuthContext();

  const params = useParams();

  const { employeeID } = params;

  return (
    <>
      <Helmet>
        <title> Create a new advanced payment</title>
      </Helmet>

      {hasPermission(
        authUser,
        'any',
        AuthPermissions.CREATE_ADVANCED_PAYMENT,
        AuthPermissions.ADMIN_PERMISSION,
        AuthPermissions.SUPER_ADMIN_PERMISSION
      ) ? (
        <AdvancedPaymentCreateView employeeID={employeeID ?? ''} />
      ) : (
        <Navigate to="/403" />
      )}
    </>
  );
}
